import { render } from "./help-popup.vue?vue&type=template&id=b050b460&scoped=true"
import script from "./help-popup.vue?vue&type=script&lang=js"
export * from "./help-popup.vue?vue&type=script&lang=js"

import "./help-popup.vue?vue&type=style&index=0&id=b050b460&scoped=true&lang=css"
import "./help-popup.vue?vue&type=style&index=1&id=b050b460&media=screen&lang=css"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b050b460"]])

export default __exports__